import Box from "@mui/material/Box";
import React, { useEffect } from "react";
import { EULA_METADATA, EULA_SECTIONS, EULA_TITLE } from "./eula-content";

function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const introSection = EULA_SECTIONS.find((section) => !section.title);
  const contentSections = EULA_SECTIONS.filter((section) => section.title);

  return (
    <Box
      component="main"
      className="bg-white min-h-screen font-sans text-gray-900"
    >
      <div className="relative bg-[#523880] py-24 overflow-hidden">
        <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-[#65308F] rounded-full blur-3xl opacity-50 mix-blend-screen"></div>
        <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-[#EE3788] rounded-full blur-3xl opacity-20 mix-blend-screen"></div>

        <div className="container relative z-10 mx-auto px-6 lg:px-40 max-w-7xl text-white">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-md px-4 py-1.5 rounded-full text-sm font-semibold mb-8 border border-white/10 shadow-lg">
            <span className="w-2 h-2 rounded-full bg-[#EE3788] animate-pulse"></span>
            <span className="tracking-wide uppercase text-[11px]">
              Legal & Compliance
            </span>
          </div>

          <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
            <div className="max-w-3xl">
              <h1 className="text-5xl lg:text-6xl font-extrabold mb-6 tracking-tight leading-[1.1]">
                Enterprise Client <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#EE3788] to-[#F482C0]">
                  Terms & Conditions
                </span>
              </h1>
              <p className="text-xl text-gray-200 leading-relaxed font-medium max-w-2xl border-l-4 border-[#EE3788] pl-6">
                {EULA_TITLE} for brands and agencies using{" "}
                <span className="text-white font-bold">Oye Creators</span>,
                operated by TTL Media Pvt. Ltd.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm p-4 rounded-xl border border-white/10 flex items-center min-w-[240px]">
              <div className="bg-[#EE3788] p-3 rounded-lg mr-4 text-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
              <div>
                <span className="block text-gray-400 text-xs uppercase tracking-wider font-bold">
                  Last Updated
                </span>
                <span className="block text-white font-bold text-lg">
                  June 26, 2026
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-6 lg:px-40 max-w-7xl py-12">
        <div className="prose prose-lg max-w-none text-gray-800">
          {introSection?.paragraphs.map((paragraph, index) => (
            <p
              key={`intro-${index}`}
              className="mb-8 text-lg leading-relaxed text-gray-800"
            >
              {paragraph}
            </p>
          ))}

          <div className="mb-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {EULA_METADATA.map((item) => (
              <div
                key={item.label}
                className="bg-gray-50 p-5 border border-gray-200 rounded-sm"
              >
                <span className="block text-xs uppercase tracking-wider font-bold text-secondary-500 mb-2">
                  {item.label}
                </span>
                <p className="text-gray-800 font-medium text-sm leading-relaxed m-0">
                  {item.value}
                </p>
              </div>
            ))}
          </div>

          <hr className="my-12 border-gray-200" />

          {contentSections.map((section, index) => (
            <section key={section.title ?? index} className="mb-14">
              <h2 className="text-2xl font-bold text-secondary-500 mb-6 pb-2 border-b border-gray-100 uppercase tracking-wide text-sm">
                {section.title}
              </h2>

              {section.highlight ? (
                <div className="my-4 p-5 bg-amber-50 border-l-4 border-amber-500 rounded-sm space-y-4">
                  {section.paragraphs.map((paragraph, paragraphIndex) => (
                    <p
                      key={`${index}-${paragraphIndex}`}
                      className="text-gray-800 font-medium leading-relaxed m-0"
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>
              ) : (
                <ul className="space-y-3 mb-0">
                  {section.paragraphs.map((paragraph, paragraphIndex) => (
                    <li
                      key={`${index}-${paragraphIndex}`}
                      className="flex items-start text-gray-800"
                    >
                      <span className="mr-2 text-primary-500 font-bold shrink-0">
                        •
                      </span>
                      <span className="font-medium leading-relaxed">
                        {paragraph}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </div>
    </Box>
  );
}

export default TermsAndConditions;
